var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loading-fragment",
      attrs: { "data-ui": "login-module-greeting" },
    },
    [
      _c(
        "CdrLink",
        { attrs: { href: "/YourAccountInfoInView" } },
        [
          _c("IconAccountProfile"),
          _vm._v(" "),
          _c("div", { staticClass: "loading-fragment__skeleton" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }